import { styled } from "@mui/material";

const StyledDiv = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
  [theme.breakpoints.up("sm")]: {
    display: "absolute",
    position: "relative",
  },
  [theme.breakpoints.up("lg")]: {
    position: "absolute",
  },

  width: "400px",
  right: "0",
  top: "0",
  bottom: "0",

  marginBottom: "0",

  "& .MuiList-root": {
    maxHeight: "300px",
    overflowY: "auto",
  },
}));

export default function SideBar({ children, side, ...rest }) {
  return <StyledDiv {...rest}>{children}</StyledDiv>;
}
